import {Component, ViewEncapsulation} from "@angular/core";

@Component({
    selector     : 'forms-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<style>
    pre {
        overflow-x: auto;
        width: 100%;
    }

    @media (min-width: 768px) {
        .navbar-brand {
            width: 100%;
        }
    }

    h4, h5 {
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
    }
</style>
<ul class="nav nav-tabs">
    <tab (trigger)="log('Worked!')">Sample Tab</tab>
</ul>
<div class="container-fluid">
    <div class="row flex-xl-nowrap">
        <div class="col-12 col-md-3 col-xl-2 nav-sidebar bg-light">
            <nav class="navbar navbar-expand-md navbar-light flex-md-column">
                <a class="navbar-brand" routerLink="/forms" routerLinkActive="active">Forms</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarNav">
                    <div class="navbar-nav flex-column">
                        <div class="nav-brand">Components</div>
                        <a class="nav-link" routerLink="check-box" routerLinkActive="active" tabindex="0" (activate)="log('Worked!')">Check Box</a>
                        <a class="nav-link" routerLink="nested-check-box" routerLinkActive="active">
                            Nested Check Box
                        </a>
                        <a class="nav-link" routerLink="nested-list" routerLinkActive="active">
                            Nested List
                        </a>

                        <a class="nav-link" routerLink="nested-field" routerLinkActive="active">
                            Nested Field
                        </a>
                        <a class="nav-link" routerLink="radio" routerLinkActive="active">Radio Buttons</a>
                        <a class="nav-link" routerLink="text-box" routerLinkActive="active">Text Box</a>
                        <a class="nav-link" routerLink="phone" routerLinkActive="active">Phone</a>
                        <a class="nav-link" routerLink="email" routerLinkActive="active">Email Address</a>
                        <a class="nav-link" routerLink="date-picker" routerLinkActive="active">Date Picker</a>
                        <a class="nav-link" routerLink="drop-down" routerLinkActive="active">
                            Drop Down (Select)
                        </a>
                        <div class="nav-brand">&nbsp;</div>
                        <div class="nav-brand">Validation</div>
                        <a class="nav-link" routerLink="./match-value" routerLinkActive="active">
                            Match Value (Confirmation)
                        </a>
                    </div>
                </div>
            </nav>
        </div>
        <main class="col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 nav-content">
            <div class="tab-content">
                <div class="tab-pane active" role="tabpanel">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </main>
    </div>
</div>
`,
    styles: [`.bs-datepicker-body .selected,.bs-datepicker-head,.bs-datepicker-head button,.btn-primary,.nav-pills .nav-link.active{background-color:#07a;color:#efefef}[class*=btn-outline].btn-secondary,[class*=btn-outline][class*=primary]{border:1px solid #07a;color:#333}[class*=btn-outline].btn-secondary:hover,[class*=btn-outline][class*=primary]:hover{background-color:#07a;color:#efefef}[class*=btn-outline][class*=danger]{border:1px solid #dc3545;color:#dc3545}[class*=btn-outline][class*=danger]:hover{background-color:#dc3545;color:#fff}[class*=btn-outline][disabled]{color:#aaa;border-color:#aaa}.input-group [class*=btn-outline]{border-color:#ced4da;background-color:#e9ecef}.ui-select-bootstrap .ui-select-multiple .ui-select-match .close{line-height:.75!important}.ui-select-bootstrap .ui-select-multiple input.ui-select-search{padding:6px 12px!important}.ui-select-multiple .ui-select-match-item,[class*=btn-transparent]{background-color:transparent;border:1px solid transparent}.ui-select-multiple .ui-select-match-item .close,[class*=btn-transparent] .close{line-height:inherit}.ui-select-multiple .ui-select-match-item.btn-secondary,.ui-select-multiple .ui-select-match-item[class*=primary],[class*=btn-transparent].btn-secondary,[class*=btn-transparent][class*=primary]{color:#07a}.ui-select-multiple .ui-select-match-item.btn-secondary:hover,.ui-select-multiple .ui-select-match-item[class*=primary]:hover,[class*=btn-transparent].btn-secondary:hover,[class*=btn-transparent][class*=primary]:hover{border:1px solid #07a}.ui-select-multiple .ui-select-match-item.btn-secondary:active,.ui-select-multiple .ui-select-match-item[class*=primary]:active,[class*=btn-transparent].btn-secondary:active,[class*=btn-transparent][class*=primary]:active{background-color:#07a;color:#fff}.ui-select-multiple .ui-select-match-item[class*=danger],[class*=btn-transparent][class*=danger]{color:#dc3545}.ui-select-multiple .ui-select-match-item[class*=danger]:hover,[class*=btn-transparent][class*=danger]:hover{border:1px solid #dc3545}.ui-select-multiple .ui-select-match-item[class*=danger]:active,[class*=btn-transparent][class*=danger]:active{background-color:#dc3545;color:#fff}.ui-select-multiple .ui-select-match-item[disabled],[class*=btn-transparent][disabled]{color:#aaa;border-color:#aaa}.form-control.expandable{resize:both;min-height:100px;height:200px;overflow-y:auto;overflow-x:auto;padding:5px}.form-control.expandable.small-expandable{height:100px}.form-control.expandable.auto-expandable{height:auto}`]
})
export class FormsDemoComponent {

    constructor() {

    }

    getRoute(path:string) {
        return ['', 'forms', path];
    }

    log(value) {
        console.log(value);
    }

}
